module.exports = __webpack_public_path__ + "img/approvals.3ee5aba5.svg";